import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'app-payment-mode',
  templateUrl: './payment-mode.component.html',
  styleUrls: ['./payment-mode.component.css']
})
export class PaymentModeComponent implements OnInit {
  StaffList=[];
  Submitted:boolean=false;
  constructor(private  payrollService: HrService,private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    searchStaffModel = {
      StaffID: 0,
      PrimaryDepartmentID: 0,
      EmployeeCategoryID: 0,
      DesignationID: 0,
      StaffIdentity: '',  
  }
  Clear  () {
    this.searchStaffModel.EmployeeCategoryID = 0;
    this.searchStaffModel.DesignationID = 0;
    this.searchStaffModel.PrimaryDepartmentID = 0;
    this.searchStaffModel.StaffIdentity = '';
    this.StaffList = [];
    
}
GetEmployee  () {
   this.spinnerService.show();
    this.payrollService.GetAllEmployeeForPaymentMode(JSON.stringify(this.searchStaffModel)).subscribe( (data:any)=> {
        this.StaffList = data.EmployeeList;
        this.spinnerService.hide();
    });
};


SavePaymentMode  () {
    this.spinnerService.show();
    this.payrollService.SavePaymentMode(JSON.stringify(this.StaffList)).subscribe( (data:any)=> {
      this.spinnerService.hide();
      this.GetEmployee();
        this.globalHelper.CheckActionStatus(data);
    });
};




  ngOnInit() {
    // this.GetEmployee();
    this.GetEmployeeCategory();
    this.GetDepartment();
     this.GetAllPaymentMode();
  }

  PaymentModeList=[];
  GetAllPaymentMode() {
    this.lookupservice.GetLookupsList('SALARYPaymentMode', '').subscribe((data: any) => {
      this.PaymentModeList = data.LookupItems;
      
    });

  }

  EmployeeCategoryList=[];
  GetEmployeeCategory() {
    this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
        this.EmployeeCategoryList = data.LookupItems;
  
    });
  };
  ListDepartment = []
  GetDepartment() {
    this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
        this.ListDepartment = data.LookupItems;
    });
  
  }
  
  DesignationList = []
  GetDesignation() {
    this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
        this.DesignationList = data.LookupItems;
    });
  };
  
}
